import { TOPIC_NAMES } from 'crm-message-bus/types/MessageTopics';
export const OPEN_DEAL_SPLITS_SIDEBAR_HANDLER = {
  topic: TOPIC_NAMES.OPEN_DEAL_SPLITS_SIDEBAR,
  type: 'MODAL',
  componentLoader: () => import('../wrappers/DealSplitsSidebar')
};